/* global debug, $, _, ko */

!function (global) {
    "use strict";

    function Tooltip($innerHtml, $appendTo, shown, position, withCloseButton, additionalClasses, destroyOnHide) {

        if (!Boolean($innerHtml)) {
            debug.error(
                'Inner html not provided, can not create tooltip', arguments || []
            );
            return;
        }

        function appendTo($newParent) {
            $newParent.find('.tooltip').remove();
            $newParent.css({position: $newParent.css('position') === 'absolute' ? 'absolute' : 'relative'});
            $template.appendTo($newParent);
            $template.data('Tooltip', tooltip);
            ko.applyBindings(tooltip, $template[0]);
            $parent = $newParent;
        }

        // Model

        var tooltip = this;
        var $parent = $appendTo;

        tooltip.shown = ko.observable(shown || true);
        tooltip.position = ko.observable(position || 'bottom-left');

        tooltip.show = function () {
            tooltip.shown(true);
        };
        tooltip.hide = function (data, event, isDestroy) {
            tooltip.shown(false);
            if (isDestroy || destroyOnHide) {
                $template.remove();
                $parent.css({position: ''});
            }
        };

        tooltip.classes = ko.computed(
            function () {
                return (additionalClasses || '') +
                    (' tooltip_' + tooltip.position()) +
                    (tooltip.shown() ? '' : ' tooltip_hidden');
            },
            tooltip
        );

        tooltip.moveTo = function ($newParent) {
            var $oldParent = $parent;

            if (!$newParent.is($oldParent)) {
                if (!!$oldParent) {
                    $oldParent.css({position: ''});
                }
                $template.detach();
                appendTo($newParent);
            }
        };

        var $template = $(_.template(
            '<div class="tooltip" data-bind="class: classes">' +
            (withCloseButton ? '<button class="tooltip__close icon-cross" data-bind="click: hide"></button>' : '') +
            '<div class="tooltip__inner">' + $innerHtml + '</div>' +
            '</div>'
        )(tooltip));

        // Inition

        if (Boolean($parent)) {
            appendTo($parent);
        }
    }

    global.Tooltip = Tooltip;

}(this);